import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import LedgerList from '@app/views/Ledger/LedgerList';
import { memo } from 'react';

export default memo(
  withIfUser(LedgerList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
